import { render } from "./SaugroboterFinderApp.vue?vue&type=template&id=45b4fff8&scoped=true"
import script from "./SaugroboterFinderApp.vue?vue&type=script&lang=js"
export * from "./SaugroboterFinderApp.vue?vue&type=script&lang=js"

import "./SaugroboterFinderApp.vue?vue&type=style&index=0&id=45b4fff8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b4fff8"]])

export default __exports__